import React, {useEffect, useState} from "react";
import { useTranslation, Trans } from "react-i18next";


//scss
import "../../scss/common.scss";
import "../../scss/component.scss";

const Error500: React.FC = () => {
  const { t, i18n } = useTranslation();
 
  return (
      <section className="pt-50 pt-100-md">
        <div className="wrap-content-900">
          <div className="card sp-small">
            <p className="mb-10 ta-c">
              <img
                src={
                  require("../../img/share/icon/icon_searchzero.svg")
                    .default
                }
                className="d-ib"
                />
            </p>
            <p className="fz-18 fw-b ta-c mb-16 c-dark_blue2">{t("通信エラーが発生しました")}</p>
            <p className="fz-16 ta-c-md c-blue_gray">
              <Trans i18nKey={"通信エラーのため情報を取得できませんでした。しばらくしてから再度お試しください。"} components={{br: <br />}} />
              
            </p>
          </div>
        </div>
      </section>
  );
};

export default Error500;
